<template>
    <div class="page meeting-list">

        <list-skeleton v-if="loading" style="margin-bottom: 100vh"></list-skeleton>

        <div v-if="list && list.length > 0" class="meeting-list-section" style="margin-top: 22px">
            <van-row @click="go_detail(item)" v-for="(item,index) in list" :key="item.id">
                <div v-if="index > 0" class="meeting-list-section-box">
                    <div class="meeting-list-section-left">
                        <van-image
                            fit="cover"
                            class="meeting-list-section-left-img"
                            :src="item.cover_img"
                            width="100%"
                            height="100%"
                        />
                        <div class="meeting-list-section-left-zl">{{item.status_text}}</div>
                    </div>
                    <div class="meeting-list-section-right">
                        <div class="meeting-list-section-right-title">{{item.title}}</div>
                        <div class="meeting-list-section-right-detail">{{item.start_at}}~{{item.end_at}}</div>
                    </div>
                    <div class="clear"></div>
                </div>
                <div v-else class="meeting-list-section-box">
                    <div class="meeting-list-section-box-first">
                        <img class="meeting-list-section-main-img" :src="item.cover_img" alt="">
                        <div class="meeting-list-section-left-zl">{{item.status_text}}</div>
                        <div class="meeting-list-section-footer">
                            <div class="meeting-list-section-footer-title">{{item.title}}</div>
                            <div class="meeting-list-section-footer-detail">{{item.start_at}}~{{item.end_at}}</div>
                        </div>
                    </div>
                    <div class="clear"></div>
                </div>
            </van-row>
        </div>
        <van-empty v-if="list.length < 2" description="" >
            <template slot="description">
                <div style="text-align: center">更多学术大会，敬请期待！</div>
            </template>
        </van-empty>
    </div>
</template>
<script>
    import Interface from "@/util/interface"
    import listSkeleton from "@/skeleton/listSkeleton"
    export default {
        name: 'meeting-list',
        components :{
            'list-skeleton' : listSkeleton
        },
        data() {
            return {
                value: "",
                active: "",
                category_id :0,
                category_index:0,
                category_child_id:0,
                banners: [],
                categories: [],
                categories_child:[],
                recommend:[],
                list:[],
                column:[],
                loading:true
            }
        },
        methods: {
            onSearch(){
                this.fetch('meeting')
            },
            onCancel() {
                this.value = ""
                this.fetch("meeting")
            },
            fetch(scene) {
                if (scene === 'meeting') {
                    let params = {
                        pageSize:999
                    }
                    Interface.getData('get', Interface.meeting.list,params).then((res) => {
                        this.list = res.data.list
                        Interface.getShareInfo(this,"学术会","","")
                        setTimeout(()=>{this.loading = false;},500)
                    })
                }
            },
            go_detail(item){
                if (item.is_saas == 2) {
                    location.href = Interface.cf+ "/#/r?m="+item.uuid
                }else{
                    if (item.type == 1){
                        location.href = "http://conference-h5.dr-gobroad.com/#/?m="+item.uuid
                    }else{
                        location.href = "http://conference-h5.dr-gobroad.com/#/live-list?m="+item.uuid
                    }
                }
            }
        },
        created() {
            this.fetch('banner')
            this.fetch('category')
            this.fetch('meeting')
            sessionStorage.removeItem("search_data")
        },
    }
</script>
<style lang="scss">
    @import "./index";

    .van-empty__image{
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/views/meeting/list/index.vue